export default [
	{
	  text: '#',
	  value: 'id',
	  width: '5%',
	},
	{
	  text: 'código interno',
	  value: 'internal_code',
	  width: '15%',
	},
  {
    text: 'códigos upc',
    value: 'upc_codes',
    component: {
      type: 'chip-list',
    },
	  align: 'center',
  },
	{
	  text: 'nombre',
	  value: 'name',
	},
	{
	  text: 'código de proveedor',
	  value: 'last_provider_code_provider',
	  width: '15%',
	},
	{
	  text: 'inventariable',
	  value: 'wh_item_is_inventoriable',
	  align: 'center',
	  format: 'boolean',
	},
	{
	  text: 'reenvasable',
	  value: 'is_repackaged',
	  align: 'center',
	  format: 'boolean',
	},
]